import React from 'react'
import { Hassan_data } from '../../assets'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'

const HassanElTamimi = () => {
  return (
      <>
      <PanelMemberTemplate {...Hassan_data}/>
      </>
  )
}

export default HassanElTamimi
